import 'react';
import styled from 'styled-components';
import sx from '../sx.js';
import { VisuallyHidden } from '../VisuallyHidden/VisuallyHidden.js';
import '@primer/behaviors/utils';
import '@primer/behaviors';
import { useId } from '../hooks/useId.js';
import classes from './Spinner.module.css.js';
import { clsx } from 'clsx';
import { jsx, jsxs } from 'react/jsx-runtime';

const sizeMap = {
  small: '16px',
  medium: '32px',
  large: '64px'
};
function Spinner({
  size: sizeKey = 'medium',
  srText = 'Loading',
  'aria-label': ariaLabel,
  className,
  style,
  ...props
}) {
  const size = sizeMap[sizeKey];
  const hasHiddenLabel = srText !== null && ariaLabel === undefined;
  const labelId = useId();
  return /*#__PURE__*/ /* inline-flex removes the extra line height */jsxs("span", {
    className: classes.Box,
    children: [/*#__PURE__*/jsxs("svg", {
      height: size,
      width: size,
      viewBox: "0 0 16 16",
      fill: "none",
      "aria-hidden": true,
      "aria-label": ariaLabel !== null && ariaLabel !== undefined ? ariaLabel : undefined,
      "aria-labelledby": hasHiddenLabel ? labelId : undefined,
      className: className,
      style: style,
      ...props,
      children: [/*#__PURE__*/jsx("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        stroke: "currentColor",
        strokeOpacity: "0.25",
        strokeWidth: "2",
        vectorEffect: "non-scaling-stroke"
      }), /*#__PURE__*/jsx("path", {
        d: "M15 8a7.002 7.002 0 00-7-7",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        vectorEffect: "non-scaling-stroke"
      })]
    }), hasHiddenLabel ? /*#__PURE__*/jsx(VisuallyHidden, {
      id: labelId,
      children: srText
    }) : null]
  });
}
Spinner.displayName = "Spinner";
const StyledBaseSpinner = styled.div.withConfig({
  displayName: "Spinner__StyledBaseSpinner",
  componentId: "sc-1knt686-0"
})(["", ""], sx);
function StyledSpinner({
  sx,
  className,
  ...props
}) {
  if (sx) {
    return /*#__PURE__*/jsx(StyledBaseSpinner, {
      sx: sx,
      as: Spinner,
      className: clsx(className, classes.SpinnerAnimation),
      ...props
    });
  }
  return /*#__PURE__*/jsx(Spinner, {
    className: clsx(className, classes.SpinnerAnimation),
    ...props
  });
}
StyledSpinner.displayName = "StyledSpinner";
StyledSpinner.displayName = 'Spinner';

export { StyledSpinner as default };
